module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.fc78759e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/Roboto-Medium.woff
// module id = 1826
// module chunks = 0